var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Objects",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 242.9 75.9",
    style: {
      enableBackground: "new 0 0 242.9 75.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#282726;}\r\n\t.st1{fill:#FCC206;}\r\n\t.st2{fill:#204992;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.8,32.7c0.7,0.3,1.5,0.5,2.3,0.5c1.4-0.1,2.7-1,3.3-2.2l-8.2-16.2h3.3l6.5,12.8l5.6-13.3l3,0.8L40,30 c-1.5,3.2-3.4,5.9-6.8,5.9c-0.8,0-1.6-0.1-2.4-0.5L30.8,32.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2,19.3h3v15.5h-3V19.3z M51.4,27.1l7.2-8.1l2,1.7l-5.8,6.2l6.9,7.9h-3.5L51.4,27.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,19.1h0.7l1.4,0.9c1.2-0.7,2.6-1.1,4-1.2c4.2,0,7.1,2.8,7.1,7.3c0,5.1-4.4,8.9-10.2,9v4.1h-3L63.9,19.1z  M66.9,22.5v10c4.6-0.1,7.2-2.8,7.2-6.3c0.2-2.4-1.6-4.4-3.9-4.6c-0.2,0-0.3,0-0.5,0C68.7,21.6,67.7,21.9,66.9,22.5L66.9,22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,19.4c1.1-0.3,2.3-0.5,3.5-0.5c4.2,0,6.1,2.2,6.1,6.3V35h-0.5l-2.1-1.1c-1.2,0.9-2.6,1.3-4.1,1.3 c-3,0-4.8-1.7-4.8-4.3c0-3.9,4.2-5.5,8.6-5.8c0.2-1.7-1.1-3.3-2.8-3.4c-0.2,0-0.4,0-0.7,0c-1.1,0-2.2,0.2-3.2,0.5L81.2,19.4z  M84.6,32.6c1.2,0,2.3-0.4,3.2-1.1v-4.2c-2.6,0.2-5.6,1.1-5.6,3.2C82.3,31.8,83.1,32.6,84.6,32.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,19.6l5.2-0.7v15.9h-2.9v-13h-2.3V19.6z M93.6,13.1h3.1l-0.3,3.4l-2.8,0.6V13.1z M98.7,13.1l3.1,0.3 l-0.7,3.1l-2.8,0.3L98.7,13.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.6,19.3h2.9v6.2h6.9v-6.2l2.9-0.3v15.8h-2.9v-6.7h-6.9v6.7h-2.9V19.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.3,18.9v2.8c-4.6,0-7.8,2.4-7.8,6c0,2.5,1.5,4.8,5.2,4.8c0.9,0,1.8-0.1,2.6-0.4v2.6 c-0.9,0.3-1.9,0.5-2.9,0.5c-5.1,0-7.9-3.4-7.9-7.5C118.5,22.8,122.8,18.9,129.3,18.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.3,32.3v-13h3v5.4h3.6c3.3,0,5.6,1.5,5.6,4.2c0,3.4-3,5.8-8.8,5.8H132L132.3,32.3z M135.3,27.1v5.2h0.5 c4.3,0,5.8-1.6,5.8-3.1c0-1.2-1.1-2-2.8-2.1L135.3,27.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.6,19.3h2.9v15.5h-2.9V19.3z M150.8,27.1l7.2-8.1l2.1,1.7l-5.8,6.2l6.9,7.9h-3.5L150.8,27.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.2,18.9c4.9,0,7.4,3.7,7.4,7.6c0,4.8-2.8,8.7-7.7,8.7s-7.4-3.7-7.4-7.6C161.5,22.8,164.3,18.9,169.2,18.9z  M164.5,27.4c0,2.7,1.5,5.1,4.4,5.1c3.2,0,4.7-2.2,4.7-5.7c0-2.7-1.4-5.1-4.4-5.1C166,21.6,164.5,23.9,164.5,27.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.4,28.1h-2.7v6.7h-2.9V19.3h2.9v6.2h2.9c0.7-3.8,3.3-6.6,7.4-6.6c4.4,0,6.8,3.7,6.8,7.6 c0,4.8-2.7,8.7-7.4,8.7C188,35.2,185.6,31.8,185.4,28.1z M188.4,27.4c0,2.7,1.3,5.2,4.1,5.2c3,0,4.5-2.2,4.5-5.8 c0-2.7-1.3-5.1-3.8-5.1C189.9,21.6,188.4,23.9,188.4,27.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.1,52.3c0-4.5,1.1-7.5,4.2-9c1.8-0.9,4.5-0.9,6-1.7l0.9-0.7l0.3,2.8c-1.6,1.1-4.8,1-6.3,1.7 C83,46,82.2,47.3,82,48.7c1.1-0.8,2.4-1.2,3.8-1.2c2.9-0.2,5.3,2,5.5,4.8c0,0.2,0,0.3,0,0.5c0,3.4-2,6.4-6.1,6.4 C81.7,59.1,79.1,56.8,79.1,52.3z M81.7,51.1c0,0.3,0,0.5,0,0.9c0,3.2,1.6,4.8,3.7,4.8c2.5,0,3.6-2,3.6-4c0.2-1.6-1-3.1-2.7-3.3 c-0.2,0-0.4,0-0.6,0C84.2,49.7,82.8,50.2,81.7,51.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.2,57.6l-3.8-11.8h2.7l3,9.6l0.6-0.9c1.6-2.2,2.5-4.9,2.7-7.6c0-0.3,0-0.6-0.1-0.9l2.5-0.5 c0.1,0.4,0.1,0.9,0.1,1.3c0,2.7-1.3,5.9-3.5,9l-4.8,6.9l-2.2-1.2L96.2,57.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,62.1h-2.4v-5.4h1.1c1.2-1.9,2.1-4,2.8-6.2l0.6-2.4h-2.2v-2.3h7l2.5-0.3v11.1h2.3l-1.2,5.5h-2.5l0.8-3.4 h-8.7L106.6,62.1z M107.9,56.6h5.6v-8.6h-2.4l-0.8,2.9C109.7,53,108.9,54.9,107.9,56.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.4,56.7v-11h2.5v4.5h3c2.7,0,4.7,1.3,4.7,3.6c0,2.9-2.6,4.9-7.4,4.9H120L120.4,56.7z M122.9,52.4v4.4h0.4 c3.6,0,4.9-1.3,4.9-2.6c0-1-0.9-1.7-2.3-1.8H122.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.9,45.8h6.7l2.5-0.3v13.3h-2.5V48h-1.9l-1.4,4.3c-0.8,2.7-2.3,5.1-4.4,6.9l-1.7-1.8 c1.8-1.5,3.1-3.5,3.9-5.8l1.1-3.7h-2.4V45.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.3,45.9c0.9-0.3,1.9-0.4,2.9-0.4c3.5,0,5.1,1.8,5.1,5.3v8.2h-0.4l-1.8-0.9c-1,0.7-2.2,1.1-3.4,1.1 c-2.5,0-4-1.4-4-3.6c0-3.3,3.5-4.6,7.2-4.9c0.1-1.5-0.9-2.7-2.4-2.9c-0.2,0-0.3,0-0.5,0c-0.9,0-1.8,0.2-2.7,0.4V45.9z M158.2,56.9 c1,0,1.9-0.3,2.7-0.9v-3.5c-2.2,0.2-4.7,0.9-4.7,2.7C156.2,56.3,156.9,56.9,158.2,56.9L158.2,56.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.9,45.5v2.3c-3.8,0-6.6,2-6.6,5c0,2.1,1.3,4,4.4,4c0.7,0,1.5-0.1,2.2-0.3v2.2c-0.8,0.3-1.6,0.4-2.4,0.4 c-4.3,0-6.6-2.9-6.6-6.3C165.8,48.8,169.4,45.5,174.9,45.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.4,45.8h2.5v13h-2.5V45.8z M180.1,52.3l6.1-6.8l1.7,1.5l-4.8,5.2l5.8,6.7h-3L180.1,52.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.4,45.9c1-0.3,1.9-0.4,2.9-0.4c3.5,0,5.1,1.8,5.1,5.3v8.2H199l-1.7-0.9c-1,0.7-2.2,1.1-3.4,1.1 c-2.5,0-4-1.4-4-3.6c0-3.3,3.5-4.6,7.2-4.9c0.2-1.4-0.9-2.7-2.3-2.9c-0.2,0-0.4,0-0.6,0c-0.9,0-1.8,0.2-2.7,0.4L191.4,45.9z  M194.3,56.9c1,0,1.9-0.3,2.7-0.9v-3.5c-2.2,0.2-4.7,0.9-4.7,2.7C192.3,56.3,193,56.9,194.3,56.9L194.3,56.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.7,
    y: 51.8,
    className: "st1",
    width: 7.9,
    height: 7.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "207.8,16.1 214.6,15.3 213.2,42.1 206.4,42.1 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8eaaf2f002e288aef4f28b18f8b493f1.svg";
export { ForwardRef as ReactComponent };